'use strict';

// PD: 28-player audio
var _throttle = require('lodash/throttle');

function fancyTimeFormat(duration) {
    // Hours, minutes and seconds
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = '';

    if (hrs > 0) {
        ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
    }

    ret += (mins < 10 ? '0' : '') + mins + ':' + (secs < 10 ? '0' : '');
    ret += '' + secs;
    return ret;
}

function audioCallback (self, classAudio) {
    // do not update progress bar if currently dragged by user
    if ($(self).parents('.cc-player[dragging]').length) {
        return;
    }
    var secondsNow = $(classAudio)[0].currentTime;
    var secondsDuration = $(classAudio)[0].duration;
    var percentuaIcons = $('.cc-button-play').width() / $('.cc-player-progress').width();
    var percentual = secondsNow / secondsDuration;
    percentuaIcons *= 1 - percentual;
    var widthPercentage = ((percentual + percentuaIcons) * 100) + '%';
    var time = fancyTimeFormat($(classAudio)[0].currentTime);
    $(self).closest('.cc-content-info').find('.cc-time-active').text(time);
    $(self).closest('.cc-content-info').find('.cc-player-progress-active').css({ width: widthPercentage });
    var audioObject = $(classAudio)[0];
    var title = $('.' + $(audioObject).data('analyticstitle')).html();
    if (percentual > 0.75 && !$(audioObject).hasClass('progress-75')) {
        $(audioObject).addClass('progress-75');
        dataLayer.push({
            event: 'custom_event',
            eventCategory: 'Audio Player',
            eventAction: title,
            eventLabel: '75%'
        });
    } else if (percentual > 0.50 && !$(audioObject).hasClass('progress-50')) {
        $(audioObject).addClass('progress-50');
        dataLayer.push({
            event: 'custom_event',
            eventCategory: 'Audio Player',
            eventAction: title,
            eventLabel: '50%'
        });
    } else if (percentual > 0.25 && !$(audioObject).hasClass('progress-25')) {
        $(audioObject).addClass('progress-25');
        dataLayer.push({
            event: 'custom_event',
            eventCategory: 'Audio Player',
            eventAction: title,
            eventLabel: '25%'
        });
    }
}

$(document).ready(function() {
    $('.js-button-play').each(function() {
        var audioID = $(this).attr('id');
        var classAudio = '.' + $(this).attr('id');
        var self = this;
        $(classAudio)[0].addEventListener('loadeddata', (event) => {
            var time = fancyTimeFormat($(classAudio)[0].duration);
            $(self).closest('.cc-content-info').find('.js-time-duration').text(time);
        });
        $(classAudio)[0].addEventListener('ended', (event) => {
            if ($(classAudio).hasClass('loop')) {
                $(classAudio)[0].currentTime = 0;
                $(classAudio)[0].play();
            } else {
                $('#' + audioID).click();
                clearInterval(audioID);
            }
            var playerObj = $(event.target).data('analyticstitle');
            var titleObj = $('.' + playerObj);
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Audio Player',
                eventAction: titleObj.html(),
                eventLabel: 'complete'
            });
            $(event.target).removeClass('progress-75');
            $(event.target).removeClass('progress-50');
            $(event.target).removeClass('progress-25');
        });

        $(classAudio)[0].addEventListener('play', (event) => {
            var playerObj = $(event.target).data('analyticstitle');
            var titleObj = $('.' + playerObj);
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Audio Player',
                eventAction: titleObj.html(),
                eventLabel: 'start'
            });
        });

        $(classAudio)[0].addEventListener('pause', (event) => {
            var playerObj = $(event.target).data('analyticstitle');
            var titleObj = $('.' + playerObj);
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Audio Player',
                eventAction: titleObj.html(),
                eventLabel: 'pause'
            });
        });
    });

    $('.js-audio-analytics-exit').on('click', function() {
        dataLayer.push({
            event: 'custom_event',
            eventCategory: 'Audio Player',
            eventAction: 'Exit to Spotify',
            eventLabel: 'exit'
        });
    });

    var audioInterval;
    $(document).on('click', '.js-button-play', function() {
        var classAudio = '.' + $(this).attr('id');
        var self = this;
        if (!$(this).parent('.cc-player').hasClass('cc-play')) {
            $(this).parent('.cc-player').addClass('cc-play');
            $(classAudio)[0].play();
            audioInterval = setInterval(function() {
                audioCallback(self, classAudio);
            }, 1000);
        } else {
            $(this).parent('.cc-player').removeClass('cc-play');
            $(classAudio)[0].pause();
            clearInterval(audioInterval);
        }
    });

    var progressBarBounds = $('.js-player-progress')[0].getBoundingClientRect();
    var progressBarStart = progressBarBounds.x;
    var iconWitdh = $('.cc-button-play').width();

    $(document).on('touchmove', '.cc-player-progress, .cc-player-progress-increased-area', _throttle(function(e){
        // set custom attribute to stop progress bar from moving every second
        $(this).parents('.cc-player').attr('dragging','');
        var posX = e.touches[0].clientX;
        // calculate progress bar width percentage
        var startFixed = posX - progressBarStart + iconWitdh;
        var percentage = (startFixed / progressBarBounds.width) * 100;
        percentage = percentage > 100 ? 100 : (percentage < 0 ? 0 : percentage );
        $(this).parent().find('.cc-player-progress-active').css('width', percentage + '%');
    }, 100));

    // remove custom dragging attribute when not dragging anymore
    $(document).on('touchend', '.cc-player-progress, .cc-player-progress-increased-area', function (e) {
        $(this).parents('.cc-player').removeAttr('dragging');
        var clientX = e.changedTouches[0].clientX;
        var startFixed = clientX - progressBarStart + iconWitdh;
        $(this).trigger('click', startFixed);
    });
});

// dragPositionX parameter is passed only when triggering this click event
// from the touchend event (end of dragging on the progress bar)
$(document).on('click', '.cc-player-progress, .cc-player-progress-increased-area', function(e, dragPositionX) {
    var targetX = dragPositionX || e.offsetX;
    var audio = $(this).siblings('audio')[0];
    var iconWitdh = $('.cc-button-play').width();
    var percentageBefore = targetX / this.clientWidth;
    var offset = targetX - iconWitdh * (1- percentageBefore);
    var percent = offset / this.clientWidth;
    audio.currentTime = percent * audio.duration;
    //$(this).parent().find('.cc-player-progress-active').css({ width: ((percent * 100) + '%') });
    audioCallback($(this).siblings('.cc-button-play'), '.' + $(this).siblings('.cc-button-play').attr('id'));
});
